import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import loadImage from "blueimp-load-image";
import Grid from "@material-ui/core/Grid";
import ReactSelect from "react-select";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import RadioItem from "../../components/RadioItem";
import { IframeTypes } from "../../Constants/selections";

import iframePageDefaultImg from "../../assets/media/iframe-page-default.png";
import remove_icon from "../../assets/media/stop.png";
import "./index.css";

const BespokeReferrals = (props) => {
  const location = useLocation();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [brandID, setBrandID] = useState();
  const [brandData, setBrandData] = useState({});
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState();

  const [inviteUrl, setInviteUrl] = useState("");
  const [referralCode, setReferralCode] = useState(false);
  const [uidPlus, setUidPlus] = useState(false);
  const [isUrlEditing, setIsUrlEditing] = useState(false);

  useEffect(() => {
    console.log("location", location);
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setLoading(true);
      setBrandID(brand);
      setUserName(username);
      setUserRole(role);
      Firebase.getBrandDataByID(brand, (res) => {
        setBrandData(res);
        if (res.bespokeReferrals) {
          console.log("bespoke referrals", res.bespokeReferrals);
          if (res.bespokeReferrals.inviteUrl) {
            setInviteUrl(res.bespokeReferrals.inviteUrl);
          }
          if (res.bespokeReferrals.referralCode) {
            setReferralCode(res.bespokeReferrals.referralCode);
          }
          if (res.bespokeReferrals.uidPlus) {
            setUidPlus(res.bespokeReferrals.uidPlus);
          }
        }
        setLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    if (brandID) {
      Firebase.updateBrandDataById(brandID, {
        bespokeReferrals: {
          inviteUrl,
          referralCode,
          uidPlus,
        },
      });
    }
  }, [referralCode, uidPlus]);

  const handleSaveUrl = () => {
    setIsUrlEditing(false);
    if (brandID) {
      Firebase.updateBrandDataById(brandID, {
        bespokeReferrals: {
          inviteUrl,
          referralCode,
          uidPlus,
        },
      });
    }
  };

  return (
    <div id="page-container">
      <Header
        username={userName}
        role={userRole}
        onHome={this.goBack}
        logo={brandData.logo}
        brand={brandID}
        brandName={brandData.name}
        is_property_brand={!!brandData.is_property_brand}
      />
      {loading ? (
        <div className="loading">
          <i className="fa fa-4x fa-sync fa-spin text-muted" />
        </div>
      ) : (
        <div className="bespoke-referrals-container">
          <div className="bespoke-url-form flex-row align-center">
            <p>Bespoke Invite URL</p>
            <input
              type="text"
              name="invite-url"
              onChange={(e) => {
                setInviteUrl(e.target.value);
              }}
              value={inviteUrl}
              disabled={!isUrlEditing}
            />
            {isUrlEditing ? (
              <i className="si si-check ml-2" onClick={() => handleSaveUrl()} />
            ) : (
              <i
                className="si si-settings ml-2"
                onClick={() => setIsUrlEditing(true)}
              />
            )}
          </div>
          <div className="referral-code-form">
            <RadioItem
              menuName="Refferal code"
              checked={referralCode}
              onYes={() => setReferralCode(true)}
              onNo={() => setReferralCode(false)}
            />
          </div>
          <div className="uid-plus-form">
            <RadioItem
              menuName="UID plus"
              checked={uidPlus}
              onYes={() => setUidPlus(true)}
              onNo={() => setUidPlus(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default BespokeReferrals;



// WEBPACK FOOTER //
// ./src/screens/BespokeReferrals/index.js